import { render, staticRenderFns } from "./PagespeedAuditOpportunityItem.vue?vue&type=template&id=33c533ca&"
import script from "./PagespeedAuditOpportunityItem.vue?vue&type=script&lang=js&"
export * from "./PagespeedAuditOpportunityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports